import React, { useState } from 'react';
import { Button, Input, Space } from 'antd';
import LoginIcon from 'components/IconAntDesign/LoginIcon';
import LogoutAsUserIcon from 'components/IconAntDesign/LogoutAsUserIcon';
import _Page_Header_User_ViewAs_styled from './_styles/_Page_Header_User_ViewAs_styled';
import { useTranslation } from 'react-i18next'



const _Page_Header_User_ViewAs = ({ user, self, authAs, mobile, before_action }) => {
  const { t } = useTranslation()
  const isViewAs = user.auser_id !== self.auser_id;
  const initial_auth_as_user = isViewAs ? user.auser_id : null;
  const [auth_as_user, setAuthAsUser] = useState(initial_auth_as_user);

  const auth_as_user_changed = auth_as_user !== initial_auth_as_user;
  const show_login_button = !isViewAs || auth_as_user_changed;

  const onChangeAuthAsUser = (e) => {
    setAuthAsUser(e.target.value);
  };

  const request_authorization = (value) => {
    const action = async () => {
      await authAs({ variables: { auth_as_user: value } })
      window.location.reload()
    }
    if (before_action?.(action)) return
    return action()
  }

  const onLogoutClick = () => request_authorization('0')
  const onLoginClick = () => {
    if (auth_as_user) return request_authorization(auth_as_user)
  }

  if (mobile) return (
    <div className="flex flex-col gap-xs">
      <label htmlFor="catalog-view-as" className="text-[12px] font-medium text-text-dark">{t('view as')}</label>
      <div className="flex items-center gap-xs">
        <Input id="catalog-view-as" placeholder={t('uuid, email or id')} data-testid="auth_as_user"
          value={auth_as_user || ''} onChange={onChangeAuthAsUser} onPressEnter={onLoginClick}
          className="!h-[40px] min-w-0 flex-1 !text-[14px]" />
        <Button type="text" aria-label={t('view as')} onClick={show_login_button ? onLoginClick : onLogoutClick}
          disabled={show_login_button && !auth_as_user} className="!h-[40px] !w-[40px] !p-0">
          {show_login_button ? <LoginIcon color="#FF7A24" /> : <LogoutAsUserIcon color="#FF7A24" />}
        </Button>
      </div>
    </div>
  )

  return (
    <_Page_Header_User_ViewAs_styled>
      <Space style={{alignItems: 'flex-end'}}>
        <label htmlFor="auth_as_user">
          <span>{t('view as')}</span>
          <Input
            name="auth_as_user"
            placeholder={t('uuid, email or id')}
            data-testid={'auth_as_user'}
            onChange={onChangeAuthAsUser}
            value={auth_as_user || ''}
            onPressEnter={onLoginClick}
          />
        </label>

        {show_login_button &&
          <LoginIcon
            onClick={onLoginClick}
            color="#FF7A24"
          />
        }

        {!show_login_button &&
          <LogoutAsUserIcon
            onClick={onLogoutClick}
            color="#FF7A24"
          />
        }
      </Space>
    </_Page_Header_User_ViewAs_styled>
  );
};

export default _Page_Header_User_ViewAs;
